import { Controller } from "@hotwired/stimulus";

const LABEL_TOGGLE = "--excerpt";
const KEY_STATE = "privacy-overlayer";
const KEY_EXPIRES = "privacy-overlay:expires_at";
const EXTEND_FORM_SELECTOR = 'form[action$="/privacy/extend"]';
const DEBOUNCE_MS = 750;
const SHIFTED_UP_CLASS = "shifted-up";

export default class extends Controller {
  static targets = ["button", "toggler"];
  static values = {
    expiresAt: Number,
  };

  get topOfSiteLink() {
    return document.querySelector(".top-of-site-link");
  }

  connect() {
    this._initializeTimerAndExpiration();
    this._restoreToggleState();
    this._observeTopOfSiteLink();
  }

  disconnect() {
    if (this.timer) clearTimeout(this.timer);
    if (this.topOfSiteLinkObserver) {
      this.topOfSiteLinkObserver.disconnect();
    }
  }

  _initializeTimerAndExpiration() {
    const nowSec = Math.floor(Date.now() / 1000);
    const remainingSeconds = Math.max(0, this.expiresAtValue - nowSec);

    this.ttlSec = remainingSeconds;

    if (remainingSeconds > 0) {
      this.timer = setTimeout(
        () => this.clickButton(),
        remainingSeconds * 1000
      );
    } else {
      this.timer = null;
    }

    window.sessionStorage.setItem(KEY_EXPIRES, String(this.expiresAtValue));
  }

  /**
   * ✅ KORRIGIERTE LOGIK: Stellt den Zustand korrekt wieder her.
   * Priorisiert den localStorage-Zustand und verwendet die Expiration-Prüfung nur als Standard.
   */
  _restoreToggleState() {
    const prevExpires =
      parseInt(window.sessionStorage.getItem(KEY_EXPIRES), 10) || 0;

    const localStorageState = window.localStorage.getItem(KEY_STATE);

    if (localStorageState === "close") {
      // 1. **Höchste Priorität:** Benutzer hat es manuell minimiert.
      this.element.classList.add(LABEL_TOGGLE);
    } else if (localStorageState === "open" || localStorageState === null) {
      // 2. Zustand ist "open" oder es gibt keinen gespeicherten Zustand.

      if (this.expiresAtValue > prevExpires) {
        // 2a. Die Server-Expiration ist neuer -> Maximiere/Öffne
        this.element.classList.remove(LABEL_TOGGLE);
        // Setze localStorage auf "open" falls es null war
        window.localStorage.setItem(KEY_STATE, "open");
      } else {
        // 2b. Die Server-Expiration ist nicht neuer -> minimiere (Standardverhalten)
        this.element.classList.add(LABEL_TOGGLE);
        // Setze localStorage auf "close" falls es null war (Sicherheitsfallback)
        window.localStorage.setItem(KEY_STATE, "close");
      }
    }
  }

  _observeTopOfSiteLink() {
    if (this.topOfSiteLink) {
      this._updateOverlayPosition();
      const observer = new MutationObserver(() =>
        this._updateOverlayPosition()
      );
      observer.observe(this.topOfSiteLink, {
        attributes: true,
        attributeFilter: ["data-visible"],
      });
      this.topOfSiteLinkObserver = observer;
    }
  }

  _updateOverlayPosition() {
    if (!this.topOfSiteLink) return;
    const isVisible = this.topOfSiteLink.dataset.visible === "true";
    this.element.classList.toggle(SHIFTED_UP_CLASS, isVisible);
  }

  clickButton() {
    if (this.buttonTarget) {
      this.buttonTarget.click();
    }
  }

  extend() {
    if (this._extendPending) return;
    this._extendPending = true;
    setTimeout(() => (this._extendPending = false), DEBOUNCE_MS);

    const nowSec = Math.floor(Date.now() / 1000);
    const ttl = this.ttlSec || Math.max(0, this.expiresAtValue - nowSec) || 60;
    const newExpires = nowSec + ttl;

    this.expiresAtValue = newExpires;
    this.element.setAttribute(
      "data-countdown-expires-at-value",
      String(newExpires)
    );

    if (this.timer) clearTimeout(this.timer);
    this.timer = setTimeout(() => this.clickButton(), ttl * 1000);

    const form = this.element.querySelector(EXTEND_FORM_SELECTOR);
    if (form) {
      if (typeof form.requestSubmit === "function") form.requestSubmit();
      else form.submit();
    }
  }

  togglerLayer() {
    this.element.classList.toggle(LABEL_TOGGLE);
    window.localStorage.setItem(
      KEY_STATE,
      this.element.classList.contains(LABEL_TOGGLE) ? "close" : "open"
    );
  }
}
